import type { ProfileUpdateRequest } from 'models/ota/ProfileUpdateRequestModel'
import { ProfileUpdateRequestStatus } from 'models/ota/ProfileUpdateRequestModel'

// Ended requests first, then the running ones, and the ones that weren't started yet last
const getStatusGroup = (request: ProfileUpdateRequest) => {
    if (request.isEnded) {
        return 0
    }
    return request.status === ProfileUpdateRequestStatus.Requested ? 2 : 1
}

// By status group, then the latest timestamp first
export const sortUpdateRequests = (requests: ReadonlyArray<ProfileUpdateRequest>): ProfileUpdateRequest[] =>
    [...requests].sort((a, b) =>
        getStatusGroup(a) - getStatusGroup(b) || b.timestampDate.getTime() - a.timestampDate.getTime()
    )
